export const enum Environment {
    LOCAL = 'local',
    STAGING = 'staging',
    PRODUCTION = 'prod',
}
